import React from 'react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Button, Modal } from 'semantic-ui-react';

@inject('astate') @observer
class DialogMsgBox extends React.Component {

	render() {
		const { dialogMsg } = this.props.astate;
		return (
			<Modal open={dialogMsg.showing} onClose={this.closeModal}>
				{dialogMsg.title !== '' && <Modal.Header>{dialogMsg.title}</Modal.Header>}
				<Modal.Content>
					{dialogMsg.message.toString()}
				</Modal.Content>
				<Modal.Actions>
					<Button primary onClick={this.closeModal}>OK</Button>
				</Modal.Actions>
			</Modal>
		)
	}

	closeModal = action(() => {
		this.props.astate.dialogMsg.showing = false;
		if (this.props.astate.dialogCloseCb) {
			this.props.astate.dialogCloseCb();
			this.props.astate.dialogCloseCb = false;
		}
	})
}

export default DialogMsgBox;



/** WEBPACK FOOTER **
 ** ./src/components/DialogMsgBox.jsx
 **/